var _defs, _circle, _g, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlgorandWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#242424;}.cls-2{fill:#fff;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "algorand-logo-freelogovectors.net_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 400,
    cy: 400,
    r: 372.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eef43819-3d4b-4f1c-88b7-757687296f2e"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "560.31 560.5 500.93 560.5 462.35 417.02 379.44 560.5 313.16 560.5 441.3 338.43 420.69 261.32 247.89 560.56 181.56 560.56 400.55 181.23 458.61 181.23 484.03 275.46 543.94 275.46 503.04 346.59 560.31 560.5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 800,
    height: 800
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgorandWallet);
export default __webpack_public_path__ + "static/media/AlgorandWallet.d1e754ca3769d8dc89804346f979d81d.svg";
export { ForwardRef as ReactComponent };